import { Routes, Route } from 'react-router-dom';
import CustomRouter from './utils/CustomRouter';
import history from './utils/history';

import Header from './components/Header';
import Home from './pages/Home';
import Footer from './components/Footer';
import MovieDetail from './pages/MovieDetail';
// import SignupPage from './pages/SignUp';
import ForgetPassword from './pages/ForgetPassword';
import SignInPage from './pages/SignIn';
import BookMoviePage from './pages/BookMoviePage';
import BookSeatsPage from './pages/BookSeatPage';
import ProfilePage from './pages/ProfilePage';
import VerifyOtp from './pages/VerifyOtp';
import Movies from './pages/Movies';
import PaymentPage from './pages/PaymentPage';
import EventPaymentPage from './pages/EventPaymentPage';
import BookingSuccessPage from './pages/BookingSucessPage';
import EventPaymentSuccess from './pages/EventPaymentSuccess';
import EventBookingSuccessPage from './pages/EventBookingSuccessPage';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import TicketPage from './pages/TicketVerifyView';
import Impressum from './pages/Impressum';
import PrivacyPolicy from './pages/PrivacyPolicy';
import ContactUs from './pages/ContactUs';
import PaymentSuccess from './pages/PaymentSuccess';
import EventDetail from './pages/EventDetail';
import EventTicketPage from './pages/EventTicketPage';
import { Suspense, useEffect } from 'react';
import ErrorBoundary from './components/ErrorBoundary';

function App() {
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        window.location.reload();
      }
    };
    window.addEventListener('pageshow', handlePageShow);
    return () => window.removeEventListener('pageshow', handlePageShow);
  }, []);

  return (
    <>
      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false}/>
      <CustomRouter history={history}>
        <ErrorBoundary>
          <Header />
          <Suspense fallback={<div className="app-loading" style={{padding: '2rem', textAlign: 'center'}}>Loading...</div>}>
            <Routes>
            <Route path="/" element={<Home />} />
            {/* <Route path="/signup" element={<SignupPage />} /> */}
            <Route path="/signin" element={<SignInPage />} />
            <Route path="/verify-otp/:email" element={<VerifyOtp />} />
            <Route path="/ForgetPassword" element={<ForgetPassword />} />
            <Route path="/movie/:slug" element={<MovieDetail />} />
            <Route path="/movies/" element={<Movies />} />
            <Route path="/book/:slug/:id" element={<BookMoviePage />} />
            <Route path="/book/seat" element={<BookSeatsPage />} />
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/stripe-payment" element={<PaymentPage />} />
            <Route path="/event-payment" element={<EventPaymentPage />} />
            <Route path="/booking-success" element={<BookingSuccessPage />} />
            <Route path="/ticket/:ticket_token" element={<TicketPage />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/payment-success" element={<PaymentSuccess />} />
            <Route path="/event-payment-success" element={<EventPaymentSuccess />} />
<Route path="/event-booking-success" element={<EventBookingSuccessPage />} />
<Route path="/event/:id" element={<EventDetail />} />
            <Route path="/customer/event/:id" element={<EventDetail />} />
            <Route path="/event-ticket/:id" element={<EventTicketPage />} />
            </Routes>
          </Suspense>
          <Footer />
        </ErrorBoundary>
      </CustomRouter>
    </>
  );

}

export default App;
